import { metrics } from 'system/libs/metrics';
import plural from 'system/libs/plural';

import { ToastNotify } from 'reactComponents/ToastNotify/ToastNotify';

import s3 from '../../s3';

export const BUCKET_OBJECTS_REMOVE_START = 'BUCKET_OBJECTS_REMOVE_START';
export function actionRemoveStart({ prefixes = [], keys = [] }) {
    return {
        type: BUCKET_OBJECTS_REMOVE_START,
        data: { prefixes, keys },
    };
}

export const BUCKET_OBJECTS_REMOVE_CANCEL = 'BUCKET_OBJECTS_REMOVE_CANCEL';
export function actionRemoveCancel() {
    return {
        type: BUCKET_OBJECTS_REMOVE_CANCEL,
    };
}

export const BUCKET_OBJECTS_REMOVE_REQUEST = 'BUCKET_OBJECTS_REMOVE_REQUEST';
function actionRemoveRequest() {
    return {
        type: BUCKET_OBJECTS_REMOVE_REQUEST,
    };
}

export const BUCKET_OBJECTS_REMOVE_SUCCESS = 'BUCKET_OBJECTS_REMOVE_SUCCESS';
function actionRemoveReceive({ prefixes, keys }) {
    return {
        type: BUCKET_OBJECTS_REMOVE_SUCCESS,
        data: { prefixes, keys },
    };
}

export const BUCKET_OBJECTS_REMOVE_FAILURE = 'BUCKET_OBJECTS_REMOVE_FAILURE';
function actionRemoveFailure({ prefixes, keys }) {
    return {
        type: BUCKET_OBJECTS_REMOVE_FAILURE,
        data: { prefixes, keys },
    };
}

export function asyncActionRemove({ Bucket, prefixes, keys }) {
    return async function(dispatch) {
        dispatch(actionRemoveRequest());

        const all = keys.length + prefixes.length;
        const removedObjects = {};
        const removedPrefixes = {};

        try {
            for (const Prefix of prefixes) {
                await s3.applyOperationToObjectsByPrefix('deleteObject', {
                    Bucket,
                    Prefix,
                });

                removedPrefixes[Prefix] = true;
            }

            for (const Key of keys) {
                await s3('deleteObject', { Bucket, Key });

                removedObjects[Key] = true;
            }

            dispatch(
                actionRemoveReceive({
                    prefixes: removedPrefixes,
                    keys: removedObjects,
                }),
            );
            metrics.send({
                action: 'RemoveFileSuccess',
            });
            ToastNotify.success(
                `${all} ${plural(all, [
                    'объект удален',
                    'объекта удалено',
                    'объектов удалено',
                ])}`,
            );
        } catch (reason) {
            metrics.send({
                action: 'RemoveFileError',
            });
            dispatch(
                actionRemoveFailure({
                    prefixes: removedPrefixes,
                    keys: removedObjects,
                }),
            );

            const allRemoved =
                Object.keys(removedPrefixes).length +
                Object.keys(removedObjects).length;

            ToastNotify.error(
                'Не удалось удалить' +
                    (all > 1 ? ` ${all - allRemoved} из ${all}` : ''),
            );
        }
    };
}
